import { render, staticRenderFns } from "./CompraPaquetes.vue?vue&type=template&id=f6b1a2a2&"
import script from "./CompraPaquetes.vue?vue&type=script&lang=js&"
export * from "./CompraPaquetes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports